module.exports = __webpack_public_path__ + "img/mp3.3d57eb0c.svg";